// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"654f8523","455":"8023608c","977":"eccfb976"}[chunkId] + ".chunk.js";
};